import React from "react";
import { ChevronDown } from "lucide-react";
import "../Vehicles/Vehicle_list/List.css";
import CommonDatePicker from "./common_date_picker";
const RCDetailsCard = ({ title = "RC details", label = "RC Number", rcNumber, onRcNumberChange, expiryDate, onExpiryDateChange, status, onStatusChange, disabled = false }) => {
  return (
    <div className="details-card">
      <h5 className="card-title">{title}</h5>

      {/* RC Number */}
      <div>
        <label className="form-label">
          {label}
          {/* <span className="text-danger">*</span> */}
        </label>
        <input type="text" className="form-control custom-input" placeholder="Enter here..." value={rcNumber} onChange={(e) => onRcNumberChange?.(e.target.value)} disabled={disabled} />
      </div>

      {/* Expiry Date */}
      <div className="d-flex flex-column mt-3">
        <label className="form-label fw-400 d-flex">
          Expiry Date
          {/* <span className="error-text">*</span> */}
        </label>
        <CommonDatePicker value={expiryDate} onChange={onExpiryDateChange} disabled={disabled} />
      </div>

      {/* Status */}
      <div className="mt-3">
        <label className="form-label">Status</label>
        <div className="input-icon-wrapper">
          <select className="form-control custom-input" value={status || ""} onChange={(e) => onStatusChange?.(e.target.value)} disabled={disabled}>
            <option value="" disabled>
              Select
            </option>
            <option value="ACTIVE">Active</option>
            <option value="EXPIRED">Expired</option>
            <option value="Fitness Expired">Fitness Expired</option>
          </select>

          <span className="icon dropdown-icon text-black">
            <ChevronDown />
          </span>
        </div>
      </div>
    </div>
  );
};

export default RCDetailsCard;
